import { render } from "./PbsGroupForm.vue?vue&type=template&id=f72c8674&ts=true"
import script from "./PbsGroupForm.vue?vue&type=script&lang=ts"
export * from "./PbsGroupForm.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__